import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { GameQuery } from '../../state/gameState/game.query';

@Component({
  selector: 'app-negotiation-title',
  templateUrl: './negotiation-title.component.html',
  styleUrls: ['./negotiation-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NegotiationTitleComponent implements OnInit {
  @Input() topic;
  @Input() dimension;

  isInformational = signal(false);

  constructor(private gameQuery: GameQuery) {}

  ngOnInit() {
    this.isInformational.set(this.gameQuery.getCurrentTopicIsInformational());
  }
}
